import React from 'react';
import { motion } from 'framer-motion';
import { useImages } from '../context/ImageContext';

const Hero = () => {
  const { images } = useImages();

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0 transition-all duration-1000"
        style={{
          backgroundImage: `url("${images.hero}")`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <div className="absolute inset-0 bg-parlor-green/50 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-parlor-green/90"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20">
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-parlor-gold uppercase tracking-[0.3em] text-sm md:text-base mb-6 font-medium"
        >
          The Artisan Touch for Your Event
        </motion.p>
        
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-serif text-5xl md:text-7xl lg:text-8xl text-parlor-cream leading-tight mb-8 text-balance"
        >
          Memories That Stick.<br className="hidden md:block" />
          <span className="italic text-parlor-gold">Artistry That Attracts.</span>
        </motion.h1>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <a 
            href="#contact"
            className="inline-block bg-parlor-gold text-parlor-green font-semibold uppercase tracking-widest px-10 py-4 hover:bg-parlor-cream transition-colors duration-300"
          >
            Book Your Event
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;